import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Text, Input } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Container } from 'styles';
import { useAdvocacyContext } from 'contexts/advocacy';
import { useGetAdvocacyRepresentatives } from 'hooks/use-get-advocacy-representatives.hook';
import { translateError } from 'utils/errors/translate-error';

const getCopy = copyFor('advocacy.address');

export const AddressForm = () => {
  const {
    typedAddress,
    setTypedAddress,
    setRepresentatives,
    stateAbbreviation,
    stateFullName,
  } = useAdvocacyContext();
  const { utilityAccountId } = useParams<{ utilityAccountId?: string }>();
  const history = useHistory();
  const [address, setAddress] = useState(typedAddress);

  const [getAdvocacyRepresentatives, { loading, data, error }] =
    useGetAdvocacyRepresentatives({
      stateAbbreviation,
      stateFullName,
    });
  const representatives = data?.representatives;

  useEffect(() => {
    if (!loading && !error && representatives) {
      setRepresentatives(representatives);
      setTypedAddress(address || '');
      history.push(routes({ utilityAccountId }).advocacyMessage);
    }
  }, [
    loading,
    error,
    representatives,
    setRepresentatives,
    setTypedAddress,
    history,
    address,
  ]);

  const handleSubmit = e => {
    e.preventDefault();
    getAdvocacyRepresentatives({
      address: address || '',
    });
  };

  return (
    <Container maxWidth="600px" width="100%">
      <Text tag="h1" margin={{ bottom: '32px' }} textStyle="heading800">
        {getCopy('title')}
      </Text>
      <form onSubmit={handleSubmit}>
        <Input
          value={address}
          label={getCopy('addressInputLabel')}
          name="address input"
          onChange={(value: string) => setAddress(value)}
          errorText={translateError(error)}
        />
        <Button
          margin={{ bottom: '24px', top: '16px' }}
          fullWidth={true}
          disabled={!address}
          loading={loading}
          type="submit"
        >
          {getCopy('button')}
        </Button>
      </form>
    </Container>
  );
};
